import React from "react";
import { Provider } from "react-redux"
import { store, history } from "./redux/store"
import PublicRoutes from "./router";
import DashAppHolder from "./dashAppStyle";
import Boot from "./redux/boot";
import * as Sentry from '@sentry/react'
import { QueryClientProvider,QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      // disable cache — always load fresh data from server
      staleTime: 0,
      cacheTime: 0,
    },
    mutations: {
      retry: 0,
    }
  },
})

const App = () => (
  <Sentry.ErrorBoundary fallback={'An error has occurred'}>
    <DashAppHolder>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <PublicRoutes history={history} />
        </QueryClientProvider>
      </Provider>
    </DashAppHolder>
  </Sentry.ErrorBoundary>
)
Boot()
  .then(() => App())
  .catch(error => console.error(error));

export default App
